// src/pages/DashboardPage.jsx
import React, { useEffect, useState } from "react";
import MainLayout from "../layout/MainLayout";
import { useNavigate } from "react-router-dom";
import { API_BASE } from "../config/orbisConfig";


function GridRowsProStyle() {
    return (
        <style>{`
            .grid-rows-pro table tbody tr {
                transition: background 0.18s ease;
            }
            .grid-rows-pro table tbody tr:nth-child(odd) {
                background: #ffffff;
            }
            .grid-rows-pro table tbody tr:nth-child(even) {
                background: #f8fafc;
            }
            .grid-rows-pro table tbody tr:hover {
                background: #eff6ff !important;
            }
            .grid-rows-pro table tbody td {
                font-size: 14px;
                color: #111827;
                vertical-align: top;
            }
            .grid-rows-pro table tbody td .grid-row-main {
                font-weight: 700;
                color: #111827;
            }
            .grid-rows-pro table tbody td .grid-row-sub {
                color: #6b7280;
                font-size: 12px;
            }
            .grid-rows-pro ul.grid-hover-list > li {
                transition: background 0.18s ease;
            }
            .grid-rows-pro ul.grid-hover-list > li:nth-child(odd) {
                background: #ffffff;
            }
            .grid-rows-pro ul.grid-hover-list > li:nth-child(even) {
                background: #f8fafc;
            }
            .grid-rows-pro ul.grid-hover-list > li:hover {
                background: #eff6ff !important;
            }
        `}</style>
    );
}

const DashboardPage = () => {
    const navigate = useNavigate();

    const [accounts, setAccounts] = useState([]);
    const [opportunities, setOpportunities] = useState([]);
    const [agendaItems, setAgendaItems] = useState([]);
    const [contacts, setContacts] = useState([]);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    // Cargar datos para el dashboard
    useEffect(() => {
        const fetchAll = async () => {
            try {
                setLoading(true);
                setError("");

                const [accRes, oppRes, agRes, conRes] = await Promise.all([
                    fetch("${API_BASE}/accounts_list.php"),
                    fetch("${API_BASE}/opportunities_list.php"),
                    fetch("${API_BASE}/activities_list.php"),     // si no existe, simplemente quedará vacío
                    fetch("${API_BASE}/contacts_list.php"),   // idem
                ]);

                const accData = await accRes.json().catch(() => []);
                const oppData = await oppRes.json().catch(() => []);
                const agData = await agRes.json().catch(() => []);
                const conData = await conRes.json().catch(() => []);

                setAccounts(Array.isArray(accData) ? accData : []);
                setContacts(Array.isArray(conData) ? conData : []);

                if (Array.isArray(oppData)) {
                    // Ordenamos de más reciente a más antiguo por id (asumiendo id incremental)
                    const orderedOpps = [...oppData].sort(
                        (a, b) => Number(b.id) - Number(a.id)
                    );
                    setOpportunities(orderedOpps);
                } else {
                    setOpportunities([]);
                }

                if (Array.isArray(agData)) {
                    // Orden por fecha si la hay
                    const orderedAgenda = [...agData].sort((b, a) => {
                        const aDate =
                            a.start_datetime ||
                            a.due_date ||
                            a.date ||
                            a.fecha ||
                            "";
                        const bDate =
                            b.start_datetime ||
                            b.due_date ||
                            b.date ||
                            b.fecha ||
                            "";
                        return aDate.localeCompare(bDate);
                    });
                    setAgendaItems(orderedAgenda);
                } else {
                    setAgendaItems([]);
                }

                console.log("Dashboard - accounts:", accData);
                console.log("Dashboard - opportunities:", oppData);
                console.log("Dashboard - agenda:", agData);
                console.log("Dashboard - contacts:", conData);
            } catch (err) {
                console.error("Error cargando dashboard:", err);
                setError("No se pudo cargar la información del dashboard.");
            } finally {
                setLoading(false);
            }
        };

        fetchAll();
    }, []);

    const formatCurrency = (val, currency = "MXN") => {
        if (val == null || val === "") return "-";
        const num = Number(val);
        if (Number.isNaN(num)) return val;
        return `${currency} ${num.toLocaleString()}`;
    };

    const formatDate = (dtString) => {
        if (!dtString) return "-";
        const [datePart] = dtString.split(" ");
        const [y, m, d] = datePart.split("-");
        if (!y || !m || !d) return dtString;
        return `${d}/${m}/${y}`;
    };

    const getStageCategory = (stageRaw) => {
        const s = (stageRaw || "").toLowerCase();
        if (s.includes("ganada")) return "won";
        if (s.includes("perdida")) return "lost";
        return "open";
    };

    const getAccountName = (account_id) => {
        const a = accounts.find((acc) => String(acc.id) === String(account_id));
        return a ? a.name : "-";
    };

    const getAgendaTitle = (item) =>
        item.title || item.subject || item.name || item.description || "Actividad";

    const getAgendaDate = (item) =>
        item.start_datetime ||
        item.due_date ||
        item.date ||
        item.fecha ||
        "";

    const getAgendaAccount = (item) =>
        item.account_name || item.account || item.empresa || "";

    // KPI principales
    const totalAccounts = accounts.length;
    const totalOpportunities = opportunities.length;
    const totalAgenda = agendaItems.length;
    const totalContacts = contacts.length;

    let totalOpen = 0;
    let totalWon = 0;
    let totalLost = 0;

    opportunities.forEach((opp) => {
        const stage = opp.stage || opp.status || "";
        const cat = getStageCategory(stage);
        if (cat === "open") totalOpen += 1;
        if (cat === "won") totalWon += 1;
        if (cat === "lost") totalLost += 1;
    });

    // Últimas 5 oportunidades
    const recentOpportunities = opportunities.slice(0, 5);

    // Próximas 5 actividades
    const upcomingAgenda = agendaItems.slice(0, 5);

    return (
        <MainLayout>
            <GridRowsProStyle />
            <div className="p-4 space-y-4 grid-rows-pro">
                {/* HEADER */}
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                    <div>
                        <h2 className="text-lg md:text-xl font-semibold text-cani-dark">
                            Dashboard CANIETI CD
                        </h2>
                        <p className="text-xs md:text-sm text-gray-500">
                            Vista ejecutiva de tu ecosistema: cuentas, oportunidades,
                            agenda y contactos. Un panel para dirigir como presidente de
                            cámara y project manager.
                        </p>
                    </div>

                    <div className="flex flex-wrap gap-2 text-xs">
                        <button
                            type="button"
                            onClick={() => navigate("/accounts")}
                            className="px-3 py-1.5 rounded-lg border border-cani-border text-cani-dark hover:bg-cani-bg"
                        >
                            Cuentas
                        </button>
                        <button
                            type="button"
                            onClick={() => navigate("/opportunities")}
                            className="px-3 py-1.5 rounded-lg bg-cani-primary text-white hover:bg-cani-primaryLight"
                        >
                            Oportunidades
                        </button>
                        <button
                            type="button"
                            onClick={() => navigate("/agenda")}
                            className="px-3 py-1.5 rounded-lg border border-cani-border text-cani-dark hover:bg-cani-bg"
                        >
                            Agenda
                        </button>
                        <button
                            type="button"
                            onClick={() => navigate("/contacts")}
                            className="px-3 py-1.5 rounded-lg border border-cani-border text-cani-dark hover:bg-cani-bg"
                        >
                            Contactos
                        </button>
                    </div>
                </div>

                {error && (
                    <div className="text-xs text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
                        {error}
                    </div>
                )}

                {/* TARJETAS KPI: CUENTAS, OPORTUNIDADES, AGENDA, CONTACTOS */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
                    {/* Cuentas */}
                    <div className="bg-white border border-cani-border rounded-xl shadow-sm p-3 flex flex-col justify-between">
                        <div className="text-[11px] text-gray-500">Cuentas activas</div>
                        <div className="text-2xl font-semibold text-cani-dark mt-1">
                            {totalAccounts}
                        </div>
                        <div className="text-[10px] text-gray-400 mt-1">
                            Empresas y aliados estratégicos dentro del ecosistema CANIETI.
                        </div>
                    </div>

                    {/* Oportunidades */}
                    <div className="bg-white border border-cani-border rounded-xl shadow-sm p-3 flex flex-col justify-between">
                        <div className="text-[11px] text-gray-500">Oportunidades</div>
                        <div className="text-2xl font-semibold text-cani-dark mt-1">
                            {totalOpportunities}
                        </div>
                        <div className="flex justify-between text-[10px] text-gray-500 mt-1">
                            <span>Abiertas: {totalOpen}</span>
                            <span>Ganadas: {totalWon}</span>
                            <span>Perdidas: {totalLost}</span>
                        </div>
                    </div>

                    {/* Agenda / Actividades */}
                    <div className="bg-white border border-cani-border rounded-xl shadow-sm p-3 flex flex-col justify-between">
                        <div className="text-[11px] text-gray-500">Actividades / Agenda</div>
                        <div className="text-2xl font-semibold text-cani-dark mt-1">
                            {totalAgenda}
                        </div>
                        <div className="text-[10px] text-gray-400 mt-1">
                            Reuniones, seguimientos y compromisos en tu rol de presidente y
                            articulador de proyectos.
                        </div>
                    </div>

                    {/* Contactos */}
                    <div className="bg-white border border-cani-border rounded-xl shadow-sm p-3 flex flex-col justify-between">
                        <div className="text-[11px] text-gray-500">Contactos</div>
                        <div className="text-2xl font-semibold text-cani-dark mt-1">
                            {totalContacts}
                        </div>
                        <div className="text-[10px] text-gray-400 mt-1">
                            Personas clave en empresas, gobierno, academia y aliados del
                            ecosistema.
                        </div>
                    </div>
                </div>

                {/* SECCIÓN INFERIOR: OPORTUNIDADES + AGENDA */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
                    {/* Columna izquierda: oportunidades recientes */}
                    <div className="lg:col-span-2 bg-white border border-cani-border rounded-xl shadow-sm overflow-hidden">
                        <div className="px-4 py-3 border-b border-cani-border flex items-center justify-between">
                            <div>
                                <h3 className="text-xs font-semibold text-cani-dark">
                                    Oportunidades recientes
                                </h3>
                                <p className="text-[10px] text-gray-500">
                                    Pipeline para Afiliados, Clientes, Proveedores, Gobiernos y Proyectos
                                    Estratégicos.
                                </p>
                            </div>
                            <button
                                type="button"
                                onClick={() => navigate("/opportunities")}
                                className="text-[11px] text-cani-primary hover:underline"
                            >
                                Ver todas
                            </button>
                        </div>

                        {loading ? (
                            <div className="px-4 py-6 text-center text-xs text-gray-500">
                                Cargando oportunidades...
                            </div>
                        ) : recentOpportunities.length === 0 ? (
                            <div className="px-4 py-6 text-center text-xs text-gray-400">
                                Aún no hay oportunidades registradas.
                            </div>
                        ) : (
                            <div className="max-h-[60vh] overflow-y-auto">
                                <table className="min-w-full text-xs">
                                    <thead className="bg-cani-bg">
                                        <tr className="text-left text-[11px] font-semibold text-gray-600">
                                            <th className="px-3 py-2">Oportunidad</th>
                                            <th className="px-3 py-2 hidden md:table-cell">Cuenta</th>
                                            <th className="px-3 py-2 hidden sm:table-cell">
                                                Etapa / Estatus
                                            </th>
                                            <th className="px-3 py-2 hidden lg:table-cell">
                                                Cierre objetivo
                                            </th>
                                            <th className="px-3 py-2 hidden sm:table-cell">
                                                Valor
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {recentOpportunities.map((opp) => {
                                            const stage = opp.stage || opp.status || "-";
                                            const value =
                                                opp.estimated_value ??
                                                opp.amount ??
                                                opp.value ??
                                                null;
                                            const currency = opp.currency || "MXN";

                                            return (
                                                <tr
                                                    key={opp.id}
                                                    className="border-t border-cani-border cursor-pointer" onClick={() => navigate(`/opportunities`)}
                                                >
                                                    <td className="px-3 py-2 text-[11px] text-cani-dark">
                                                        <div className="font-medium">{opp.name}</div>
                                                        {opp.description && (
                                                            <div className="text-[10px] text-gray-500">
                                                                {opp.description}
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td className="px-3 py-2 hidden md:table-cell text-[11px] text-gray-600">
                                                        {getAccountName(opp.account_id)}
                                                    </td>
                                                    <td className="px-3 py-2 hidden sm:table-cell text-[11px] text-gray-600">
                                                        {stage}
                                                    </td>
                                                    <td className="px-3 py-2 hidden lg:table-cell text-[11px] text-gray-600">
                                                        {opp.close_date
                                                            ? formatDate(opp.close_date)
                                                            : "-"}
                                                    </td>
                                                    <td className="px-3 py-2 hidden sm:table-cell text-[11px] text-gray-700">
                                                        {formatCurrency(value, currency)}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>

                    {/* Columna derecha: agenda / próximas actividades */}
                    <div className="bg-white border border-cani-border rounded-xl shadow-sm overflow-hidden">
                        <div className="px-4 py-3 border-b border-cani-border flex items-center justify-between">
                            <div>
                                <h3 className="text-xs font-semibold text-cani-dark">
                                    Próximas actividades
                                </h3>
                                <p className="text-[10px] text-gray-500">
                                    Reuniones, follow-ups y actividades clave de liderazgo.
                                </p>
                            </div>
                            <button
                                type="button"
                                onClick={() => navigate("/agenda")}
                                className="text-[11px] text-cani-primary hover:underline"
                            >
                                Ver agenda
                            </button>
                        </div>

                        {loading ? (
                            <div className="px-4 py-6 text-center text-xs text-gray-500">
                                Cargando agenda...
                            </div>
                        ) : upcomingAgenda.length === 0 ? (
                            <div className="px-4 py-6 text-center text-xs text-gray-400">
                                No hay actividades registradas.
                            </div>
                        ) : (
                            <div className="max-h-[60vh] overflow-y-auto">
                                <ul className="divide-y divide-cani-border text-xs">
                                    {upcomingAgenda.map((item) => {
                                        const rawDate = getAgendaDate(item);
                                        return (
                                            <li key={item.id} className="px-4 py-3 hover:bg-cani-bg/60">
                                                <div className="text-left flex justify-between items-left gap-2">
                                                    {rawDate && (
                                                        <div className="text-left text-[10px] text-gray-500">
                                                            {formatDate(rawDate)}
                                                        </div>
                                                    )}
                                                    <div>
                                                        <div className="text-left text-[11px] font-medium text-cani-dark">
                                                            {getAgendaTitle(item)}
                                                        </div>
                                                        {getAgendaAccount(item) && (
                                                            <div className="text-left text-[10px] text-gray-500">
                                                                {getAgendaAccount(item)}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default DashboardPage;
